const textFieldFormService = {
  accountable: 'Responsável',
  document: 'Documento (RG ou CPF)',
  description: 'Comentários'
};

export default textFieldFormService;
